import { type ProfileState, profile$ } from "@/lib/profile";
import { useObservable } from "./useObservable";

const initial: ProfileState = { user: null, profile: null, loading: true };

export function useProfile(): ProfileState {
  return useObservable(profile$, initial);
}
